import { AdpEarningsDefinition, AdpImportFileDefinitionCreateRequest, AdpImportFileDefinitionResponse, AdpImportFileDefinitionSelectResponse } from "@herbjoy/apex-api-models";
import { IHttpService, IPromise, IQService } from "angular";

export enum AdpExportFormat {
    Default,
    DefaultWithSsn,
    Canada,
    Pivoted
}

export interface AdpExportFormatSelection {
    format: AdpExportFormat;
    name: string;
    apiExtension: string;
    defaultConfigName?: string;
}

const FORMATS: AdpExportFormatSelection[] = [{
    format: AdpExportFormat.Default,
    name: "Default",
    apiExtension: "adp-import-file.csv",
    defaultConfigName: "Default"
}, {
    format: AdpExportFormat.DefaultWithSsn,
    name: "Default w/ SSN",
    apiExtension: "non-hj-import-file.csv",
    defaultConfigName: "Default"
}, {
    format: AdpExportFormat.Canada,
    name: "Canada",
    apiExtension: "adp-canada-import-file.csv",
    defaultConfigName: "Canada"
}, {
    format: AdpExportFormat.Pivoted,
    name: "Revised Payroll Upload",
    apiExtension: "pivoted-payroll-upload.csv",
    defaultConfigName: "Default"
}];

export class AdpConfigService {
    baseUrl: string;
    constructor(private $http: IHttpService, private $q: IQService, apexApiUrl: string) {
        'ngInject';
        this.baseUrl = `${apexApiUrl}payrolls/adp-config/definitions`
    }

    retrieveAdpImportDefinitions(): IPromise<AdpImportFileDefinitionSelectResponse[]> {
        return this.$http<AdpImportFileDefinitionSelectResponse[]>({
            method: "GET",
            url: `${this.baseUrl}`
        }).then(response => response.data);
    }

    retrieveDefaultImportDefinition(payrollID: number): IPromise<AdpImportFileDefinitionResponse> {
        return this.$http<AdpImportFileDefinitionResponse>({
            method: "GET",
            url: `${this.baseUrl}/default/${payrollID}`
        }).then(response => response.data);
    }

    retrieveAdpImportDefinition(id: number): IPromise<AdpImportFileDefinitionResponse> {
        return this.$http<AdpImportFileDefinitionResponse>({
            method: "GET",
            url: `${this.baseUrl}/${id}`
        }).then(response => response.data);
    }

    createAdpImportDefinition(request: AdpImportFileDefinitionCreateRequest): IPromise<number> {
        return this.$http<number>({
            method: "POST",
            url: `${this.baseUrl}`,
            data: request
        }).then(response => response.data);
    }

    updateAdpImportDefinition(id: number, definitions: AdpEarningsDefinition[]): IPromise<void> {
        return this.$http<void>({
            method: "PUT",
            url: `${this.baseUrl}/${id}`,
            data: {
                definitions
            }
        }).then(response => response.data);
    }

    renameAdpImportDefinition(id: number, name: string): IPromise<void> {
        return this.$http<void>({
            method: "PUT",
            url: `${this.baseUrl}/${id}/name/${name}`
        }).then(response => response.data);
    }

    deleteAdpImportDefinition(id: number): IPromise<void> {
        return this.$http<void>({
            method: "DELETE",
            url: `${this.baseUrl}/${id}`
        }).then(response => response.data);
    }

    retrieveAdpExportFormats(): IPromise<AdpExportFormatSelection[]> {
        return this.$q.resolve(FORMATS);
    }
}
